import React, { MutableRefObject } from "react";
import Checkbox from "antd/lib/checkbox";
import Radio from "antd/lib/radio";
import Form, { RuleObject } from "antd/lib/form";
import { SurveyInput } from "pages/symptoms/surveyForms/surveyInput";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface PainSectionProps {
  readonly currentPage: number;
  setOtherPainTempInput(input: string): void;
  readonly otherPainTempInput: string;
  readonly otherPainInputRef: MutableRefObject<string>;
}

export const PainSection: React.FC<PainSectionProps> = ({
  currentPage,
  otherPainInputRef,
  otherPainTempInput,
  setOtherPainTempInput
}) => {
  const validateWhereIsYourPain = (
    rules: RuleObject,
    value: string,
    callback: (error?: string) => void
  ) => {
    if (
      otherPainInputRef.current === "" &&
      localStorage.getItem("whereIsYourPain")?.includes("Other")
    ) {
      callback("Please enter value for 'Other' field.");
    } else {
      callback();
    }
  };

  return (
    <>
      {currentPage === 5 && (
        <SurveyQuestionCard
          sectionTag="PAIN"
          title="Have you had any pain?"
          required
        >
          <FormItemStyle
            name="Have you had any pain"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("hadAnyPain")}
              onChange={e => localStorage.setItem("hadAnyPain", e.target.value)}
            >
              <AnswerList>
                <AnswerOption value="Yes">Yes</AnswerOption>
                <AnswerOption value="No">No</AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 6 && (
        <SurveyQuestionCard
          sectionTag="PAIN"
          title="Where is your pain?"
          required
        >
          <div
            style={{
              color: "#e53935",
              fontWeight: 700,
              marginBottom: "12px",
              fontSize: "14px"
            }}
          >
            ** PLEASE BE SURE TO CALL YOUR DOCTOR OR SEEK EMERGENCY CARE IF YOU
            ARE REPORTING ANY SYMPTOMS BELOW **
          </div>
          <FormItemStyle
            name="Where is your pain"
            label=""
            initialValue={""}
            rules={[
              { required: true },
              { validator: validateWhereIsYourPain, validateTrigger: "submit" }
            ]}
          >
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={e =>
                localStorage.setItem("whereIsYourPain", e.toString())
              }
              value={localStorage.getItem("whereIsYourPain")?.split(/,/)}
            >
              <AnswerList>
                <AnswerOption
                  value="Over either flank (either side of your back, below your rib cage)"
                  isCheckbox
                >
                  Over either flank (either side of your back, below your rib
                  cage)
                </AnswerOption>
                <AnswerOption value="Low back pain" isCheckbox>
                  Low back pain
                </AnswerOption>
                <AnswerOption value="Groin pain" isCheckbox>
                  Groin pain
                </AnswerOption>
                <AnswerOption value="Abdominal pain" isCheckbox>
                  Abdominal pain
                </AnswerOption>
                <AnswerOption value="Other" isCheckbox>
                  <div style={{ width: "100%" }}>
                    <span>Other</span>
                    <SurveyInput
                      value={otherPainTempInput || otherPainInputRef.current}
                      placeholder="Please specify"
                      onChange={e => {
                        setOtherPainTempInput(e.target.value);
                        otherPainInputRef.current = e.target.value;
                      }}
                      style={{ marginTop: "8px", width: "100%" }}
                    />
                  </div>
                </AnswerOption>
              </AnswerList>
            </Checkbox.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
